import {BaseService} from "./base.service";

class SupplierRadiologyService extends BaseService {

    constructor() {
        super('api/radiology')
    }
}

export const supplierradiologyService = new SupplierRadiologyService();
